import { useEffect, useState } from 'react';

export function useDebouncedValue<T>(
  value: T,
  delayMs: number,
  enabled = true
): T {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    if (!enabled) {
      setDebounced(value);
      return;
    }

    const timeoutId = window.setTimeout(() => {
      setDebounced(value);
    }, delayMs);

    return () => {
      window.clearTimeout(timeoutId);
    };
  }, [value, delayMs, enabled]);

  return enabled ? debounced : value;
}
